import React, { Component } from 'react'
import Link from 'gatsby-link'
import Logo from '../Logo/Logo'
import Brand from '../Brand/Brand'

import styles from './Header.module.scss'

class Header extends Component {
	render () {
		const { onMenuButtonClick } = this.props
		return (
			<header className={styles.headerContainer}>
				<div className={styles.header}>
					<Link to="/" className={styles.headerItem}>
						<Logo containerClassName={styles.logo} fill="#3f415e" />
					</Link>
					<a href="https://www.radionacional.co/" className={styles.headerItem}>
						<Brand containerClassName={styles.brand} />
					</a>
					<div className={styles.menuActionContainer}>
						<button onClick={onMenuButtonClick} name="menu">
							<img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDM0IDI0Ij4gIDxnIGZpbGw9IiNGRjc1MDAiIGZpbGwtcnVsZT0iZXZlbm9kZCI+ICAgIDxyZWN0IHdpZHRoPSIzNCIgaGVpZ2h0PSIyIi8+ICAgIDxyZWN0IHdpZHRoPSIzNCIgaGVpZ2h0PSIyIiB5PSIxMSIvPiAgICA8cmVjdCB3aWR0aD0iMzQiIGhlaWdodD0iMiIgeT0iMjIiLz4gIDwvZz48L3N2Zz4=" title="Menú" alt="Menú" />
						</button>
					</div>
				</div>
			</header>
		)
	}
}
export default Header


// WEBPACK FOOTER //
// ./src/components/Header/Header.js